import { addSEOSupportToURL } from "../../../utils/gatsby-helpers";

const getFaqSubCatURL = (lang, subCategoryTitle) =>
	`/${lang}/faqs/${addSEOSupportToURL(subCategoryTitle)}`;

export default getFaqSubCatURL;
export { getFaqSubCatURL };
